/* eslint-disable react/destructuring-assignment */

import { IconProp } from '@fortawesome/fontawesome-svg-core';
import * as React from 'react';
import { ButtonProps as IButtonProps } from 'reactstrap';

import Icon from '../utils/icon';

import styles from './button.module.scss';

export interface ButtonProps extends IButtonProps {
  text: string;
  className?: string;
  onClick?: React.MouseEventHandler<any>;
  allCapitals?: boolean;
  icon?: IconProp;
  inverseColours?: boolean;
  slimButton?: boolean;
  alignIconRight?: boolean;
  disabled?: boolean;
  fill?: boolean;
  type?: 'button' | 'reset' | 'submit';
  form?: string;
}

export default class Button extends React.Component<ButtonProps> {
  private formatText() {
    if (this.props.allCapitals) {
      return this.props.text.toUpperCase();
    }

    return this.props.text;
  }

  public render() {
    const className = `${this.props.className} ${this.props.inverseColours ? styles.invertedButton : styles.button}`;

    return (
      // eslint-disable-next-line react/button-has-type
      <button
        className={`${className} ${this.props.fill ? styles.fill : ''}
     ${this.props.alignIconRight ? styles.paddingLeft : styles.paddingRight} `}
        onClick={this.props.onClick}
        disabled={this.props.disabled}
        type={this.props.type}
        form={this.props.form}
      >
        {this.props.icon && !this.props.alignIconRight && (
          <Icon icon={this.props.icon} noMargins={this.props.slimButton || this.props.fill} />
        )}
        <span className={styles.text}>{this.formatText()}</span>
        {this.props.icon && this.props.alignIconRight && (
          <Icon icon={this.props.icon} noMargins={this.props.slimButton || this.props.fill} />
        )}
      </button>
    );
  }
}
